import { type SupportedLocaleMap } from '@zep-us/i18n';

import { type MapTemplateUserRes } from '@/api';
import { type CommonTranslationKeys } from '@/types/translation';

export type MapTemplateType = 'linear' | 'free' | 'total' | 'team' | 'round';
export const MapTemplateTypeLocaleKey: Record<
  MapTemplateType,
  CommonTranslationKeys
> = {
  linear: 'map.type.linear',
  free: 'map.type.free',
  total: 'map.type.total',
  team: 'map.type.team',
  round: 'map.type.round',
};

export const MapTemplateTypes: MapTemplateType[] = [
  'total',
  'linear',
  'free',
  'round',
  'team',
];

export interface MapTemplateLocalize {
  name: string;
  locale: string;
  type?: string;
  description: string[];
  previewPlayUrl?: string;
}

export interface MapTemplate extends MapTemplateUserRes {
  type: MapTemplateType;
  localizeData: MapTemplateLocalize[];
  serializedLocalize: SupportedLocaleMap<
    'ko' | 'en' | 'ja',
    MapTemplateLocalize
  >;
}
